import {
  EnvironmentNames,
  getEnvironmentName
} from '../environments/is-environment';

export const getFirstPartyResource = () => {
  const currentEnvironment = getEnvironmentName();

  switch (currentEnvironment) {
    case EnvironmentNames.dev:
      return 'https://ceh-dev.teams.microsoft.com';
    case EnvironmentNames.canary:
      return 'https://cehclient-canary.teams.microsoft.com';
    case EnvironmentNames.ppe:
      return 'https://cehclient-ppe.teams.microsoft.com';
    case EnvironmentNames.prod:
      return 'https://cehclient.teams.microsoft.com';
    default:
      return 'https://cehclient.teams.microsoft.com';
  }
};
